// BlankLayout.jsx
import React from "react";

const BlankLayout = ({ children }) => {
  return (
    <div
      className="bg-white w-full flex flex-col"
      style={{
        minHeight: "100vh",
        minHeight: "-webkit-fill-available", // iOS Safari
        height: "100dvh", // Dynamic viewport height for mobile Safari
      }}
    >
      <div className="w-full max-w-7xl mx-auto flex-1 flex flex-col min-h-0">
        {children}
      </div>
    </div>
  );
};

export default BlankLayout;
